<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
                        @change="handleStoreChange">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份">
                    <el-date-picker v-model="dateStr" type="month" size="small" :default-value="new Date()"
                        :editable="false" :clearable="false" placeholder="请选择月份" format="yyyy-MM" @change="dateChange">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button v-if="this.$checkBtnPermission('/storeCost/statistic/store', 'viewPage')" size="small"
                        type="primary" class="el-icon-search" @click="getListData()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
            <span class="content_title">
                {{ this.title }}
            </span>

            <el-table :data="listData" v-loading="loading" border stripe ref="table" :highlight-selection-row="true" style="border-radius: 10px;"
                empty-text="暂无数据" :header-cell-style="{ backgroundColor: '#b3e0ff' }"
                height="600px">
                <el-table-column prop="rowNumber" label="序号" align="center" fixed="left" width="80" isKeep="true">
                </el-table-column>
                <el-table-column prop="storeName" label="门店名称" fixed="left" isKeep="true" width="120" align="center">
                </el-table-column>
                <el-table-column prop="userName" label="打卡员工" fixed="left" width="100" align="center">
                </el-table-column>
                <el-table-column v-for="m in new Date(formInline.year, formInline.month, 0).getDate()" :key="m"
                    :label="m + '号'" width="150" align="center">
                    <el-table-column prop="listMorningTime[m-1]" label="上午" fixed="left" width="70" align="center">
                        <template slot-scope="scope">
                            <span
                                v-if="scope.row.listMorningTime && scope.row.listMorningTime.length > 0 && scope.row.listMorningTime[m - 1] && scope.row.listMorningTime[m - 1].length > 0">
                                <span v-for="value in scope.row.listMorningTime[m - 1]" :key="'morning' + m + value"
                                    class="text-green">
                                    {{ value }}
                                </span>
                            </span>
                            <span v-else class="text-red">
                                ×
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="listAfternoonTime[m-1]" label="下午" fixed="left" width="70" align="center">
                        <template slot-scope="scope">
                            <span
                                v-if="scope.row.listAfternoonTime && scope.row.listAfternoonTime.length > 0 && scope.row.listAfternoonTime[m - 1] && scope.row.listAfternoonTime[m - 1].length > 0">
                                <span v-for="value in scope.row.listAfternoonTime[m - 1]" :key="'afternoon' + m + value"
                                    class="text-green">
                                    {{ value }}
                                </span>
                            </span>
                            <span v-else class="text-red">
                                ×
                            </span>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </topTab>
    </div>
</template>

<script>
import {
    GetAttendanceStatistic
} from "@/api/storeCostApi.js";
import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
export default {
    data() {
        return {
            loading: false, // 显示加载
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "费用统计",
                },
            ],
            listData: [],
            formInline: {
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                storeKeyId: "",
            },
            title: "门店考勤统计",
            storeList: [],
            dateStr: new Date(),
            storeName: ""
        };
    },
    // 注册组件
    components: {
    },
    created() {
        this.getListData();
        this.GetOrgInfoListByConfig();
    },
    computed: {},
    methods: {
        changePages() { },
        // 获取列表
        getListData() {
            this.loading = true;
            this.title = this.formInline.year + "年" + this.formInline.month + "月" + this.storeName + "门店考勤统计";
            GetAttendanceStatistic(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.listData = res.data.items;
                        // 数据更新后，使用$nextTick确保DOM已更新，然后调用doLayout重绘表格，修复固定列偏移问题
                        this.$nextTick(() => {
                            if (this.$refs.table) {
                                this.$refs.table.doLayout();
                            }
                        });
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                }).finally(() => {
                    this.loading = false;
                });
        },
        // 搜索事件
        search() {
            this.getListData();
        },
        // 门店选择器change事件
        handleStoreChange(val) {
            if (this.storeList.length > 0) {
                const foundStore = this.storeList.find(item => item.keyId === val);
                this.storeName = foundStore ? foundStore.value : '';
            }
            this.getListData();
        },
        // 日期选择器change事件
        dateChange() {
            this.formInline.year = this.dateStr.getFullYear();
            this.formInline.month = this.dateStr.getMonth() + 1;
            this.getListData();
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0 || columnIndex === 1) {
                if (rowIndex % this.typeCount === 0) {
                    return {
                        rowspan: this.typeCount,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
    },
};
</script>

<style scoped lang="scss">
.content_title {
    font-size: 32px;
    font-weight: 700;
    display: block;
    text-align: center;
    margin-bottom: 20px;
}

.text-red {
    color: red;
    font-size: 24px;
    font-weight: 700;
}

.text-green {
    display: inline-block;
    background-color: green;
    margin-bottom: 3px;
    color: #fff;
    border-radius: 5px;
    height: 24px;
    line-height: 24px;
}
</style>